import { html, SYSTableDefIds } from "../../../../.."
import { T } from "../../../../../textapi"
import { DialogOpen } from "../../../../dialog/dialogapi"
import {
  FieldForceChange,
  FieldIsVisible,
  FieldSetVal,
  FieldVal,
  SYSField,
} from "../../../../forms/fieldapi"
import { FormIsValid } from "../../../../forms/formapi"
import { SYSFormElement } from "../../../../forms/sysformelement"
import {
  SYSTableDef,
  TableFormAddRow,
  TableFormEditRow,
  TableGet,
  TableRefresh,
} from "../../../tableapi"
import {
  _FilterSortChanged,
  _GetCurrentActiveTableSettingsFilterSortJsonString,
  _GetFilterSortPermission,
} from "../../tablesettings/helpers"

export class SYSHeaderMenuFilterSortSettings extends SYSFormElement {
  tableDefId: SYSTableDefIds
  tableDef: SYSTableDef
  instance: string
  async init() {
    this.formType = "SYSHeaderMenuFilter"
    this.formId = this.instance
    this.tableDef = TableGet(this.tableDefId).def
    this.formIgnoreAutomaticFocusSet = true
    await super.init()
  }

  tagForUpdate(field: SYSField) {
    let filterSort = this.state.ovl.libState.tableSettings.filterSort
    filterSort.fieldToUpdate.formType = this.formType
    filterSort.fieldToUpdate.formId = this.formId
    filterSort.fieldToUpdate.fieldKey = field.fieldKey
    filterSort.currentFilterSortSettings =
      _GetCurrentActiveTableSettingsFilterSortJsonString(this.tableDefId)
  }

  async getUI() {
    let field = this.formState.fields["HeaderMenuSelectPersistedFilterSort"]
    let filterSortPermissions = _GetFilterSortPermission(this.tableDefId)
    let chkTable = TableGet("SYSTableSettings_FilterSort")
    if (!FieldIsVisible(field)) {
      return undefined
    }
    let val = FieldVal(field, { mode: "Converted" })
    let formIsValid = FormIsValid(this.formState)
    let editButtons
    let hasForcedFilter = !!TableGet(this.tableDefId).def.uiState.filter.filter
      .forcedFilterKeys
    let hasFilterSortChanges = ""
    let fsresult = _FilterSortChanged(this.tableDefId)
    if (fsresult.changed || hasForcedFilter) {
      hasFilterSortChanges = "fd-button--attention is-selected"
    }
    if (fsresult.favoriteInvalid) {
      hasFilterSortChanges = `${hasFilterSortChanges} __invalidfavorite`
    }
    let editButton
    let addButton
    let settingsButton
    let undoButton

    let row = chkTable.rows[chkTable.getKeys({ byIdValue: val })[0]]
    if (!row) {
      // eg. if one user deletes the fav and this one refreshes its gone
      // set to default in that case
      val = undefined
      //await FieldSetVal(field, "")
    }
    if (!hasFilterSortChanges && val) {
      undoButton = html`
        <button
          class="fd-button"
          title="${T("Refresh")}"
          @click=${async (e) => {
            // get old val so we know after refresh if the current selected changed
            let beforeRowString = `${row.U_Desc}${row.U_FilterSortSettings}`
            await TableRefresh("SYSTableSettings_FilterSort")
            let afterRowString = `${row.U_Desc}${row.U_FilterSortSettings}`
            if (beforeRowString !== afterRowString) {
              chkTable.def.uiState.filter.filter.forcedFilterKeys = undefined
              FieldForceChange(field)
            }
          }}
        >
          <i class="sap-icon--refresh"></i>
        </button>
      `
    } else {
      undoButton = html`
        <button
          class="fd-button ${hasFilterSortChanges}"
          title="${fsresult.favoriteInvalid
            ? T("SYSFilterFavoriteInvalid")
            : T("SYSTableSettingsFilterSortUndo")}"
          ?disabled=${!formIsValid}
          @click=${async (e) => {
            await TableRefresh("SYSTableSettings_FilterSort")
            chkTable.def.uiState.filter.filter.forcedFilterKeys = undefined
            FieldForceChange(field)
          }}
        >
          <i class="sap-icon--undo"></i>
        </button>
      `
    }
    if (filterSortPermissions.modifyLevel) {
      let addEnabled = formIsValid && !!val
      let editEnabled = false
      if (addEnabled) {
        let forCardCode = row["CanBeUsedBy"]
        editEnabled =
          filterSortPermissions.modifyLevel === "all" ||
          forCardCode === null ||
          forCardCode === "@@SYSUser" ||
          (filterSortPermissions.modifyLevel === "company" &&
            forCardCode === this.state.ovl.user.cardCode)
      }
      let moreEnabled =
        chkTable.getKeys({ byKeys: "StaticFiltered" }).length > 0

      editButton = html`
        <button
          class="fd-button"
          title="${T("SYSTableSettingsFilterSortEdit")}"
          ?disabled=${!editEnabled || !hasFilterSortChanges}
          @click=${async (e) => {
            let table = TableGet(
              <SYSTableDefIds>"SYSTableSettings_FilterSort",
              {
                byIdValue: val,
              }
            )
            // we need to remember the field
            // because if user changes name it should be directly reflected in this formstate as well

            this.tagForUpdate(field)

            await TableFormEditRow(
              <SYSTableDefIds>"SYSTableSettings_FilterSort",
              table.getKeys()[0]
            )
          }}
        >
          <i class="sap-icon--save"></i>
        </button>
      `

      addButton = html`
        <button
          class="fd-button"
          title="${T("SYSTableSettingsFilterSortAdd")}"
          ?disabled=${!(!val || addEnabled)}
          @click=${async (e) => {
            this.tagForUpdate(field)
            await TableFormAddRow("SYSTableSettings_FilterSort")
          }}
        >
          <i class="sap-icon--add-favorite"></i>
        </button>
      `

      settingsButton = html`
        <button
          class="fd-button"
          title="${T("SYSTableSettingsFilterSortSettings")}"
          ?disabled=${!moreEnabled}
          @click=${async () => {
            this.tagForUpdate(field)
            await DialogOpen("SYSTableSettings_FilterSort")
          }}
        >
          <i class="sap-icon--favorite-list"></i>
        </button>
      `
    }
    if (!this.state.ovl.libState.localHitListState.open) {
      editButtons = html`<div
        class="fd-segmented-button"
        role="group"
        aria-label="Tablefiltercontrol"
      >
        ${undoButton} ${editButton} ${addButton} ${settingsButton}
      </div>`
    }

    let list
    list = html`<ovl-listcontrol .props=${() => field}></ovl-listcontrol>`
    let res

    res = html`
      <div class="ovl-headermenufiltersortsettings">${list} ${editButtons}</div>
    `

    return html`<li class="fd-list__item" role="listitem">
      <span class="fd-list__icon sap-icon--favorite corrfiltersorticon"></span>
      ${res}
    </li>`
  }
}
